import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, ShieldCheck } from 'lucide-react';
const HeaderGlp6TipsG = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17430" data-mp="23kwvzg49pkav">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17431" data-mp="1tl5wt14rih4g"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17432" data-mp="1tn8w6brt1mlu">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17433" data-mp="2hbs5mumlc5fi">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17434" data-mp="2m91sq3mic506">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17435" data-mp="28glx3nvxr99a">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17436" data-mp="308bc1c60ff8d">
          <div className="text-left" data-id="element-17437" data-mp="352fepj88t13n">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17438" data-mp="1z3lhheiiiyhl">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17439" data-mp="2hri6eojhl42k">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17440" data-mp="2rrr7ogsc5fot">
        <div className="max-w-4xl mx-auto" data-id="element-17441" data-mp="2mseihpdzrwj2">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17442" data-mp="2mtpnfsj6babr">
            PERSONAL REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-2" data-id="element-17443" data-mp="sen4kdomqqht">
            Why Does Semaglutide Make You Feel The Way You Feel—And What
            Actually Helps?
          </h1>
          <p className="text-base sm:text-lg text-gray-600 italic mb-5" data-id="element-17444" data-mp="2xexx8l52wqbp">
            (From a Former Nurse Who Lost Everything on GLP-1s—Then Found Her
            Way Back)
          </p>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-17445" data-mp="36gxf1fnx3yfp">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-17446" data-mp="3bfih7kmqcs6s">
              <img src="https://cdn.magicpatterns.com/uploads/qo1VVrn8u2FTESbwCETPV1/1.jpg" alt="Dr. Tom Parham" className="w-full h-full object-cover" data-id="element-17447" data-mp="3ge217fhrjtwi" />
            </div>
            <div className="flex-1" data-id="element-17448" data-mp="3l7o4wi5y8ng6">
              <div className="flex items-center" data-id="element-17449" data-mp="3p75adbldlklc">
                <div className="font-medium text-gray-900 text-lg" data-id="element-17450" data-mp="3p8zw2s4h1gqh">
                  By Patricia Morrison, RN, CN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-17451" data-mp="2z5ps9161sl7">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-17452" data-mp="2xcgsn32ywa1" />
                  <span className="text-xs ml-1 font-medium" data-id="element-17453" data-mp="d4f4lh7d4uwl">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17454" data-mp="837v9dpknnnt">
                Chicago, IL • Former Medical Practitioner • 58 Years Old • 4
                Years on GLP-1 Medications
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-17455" data-mp="3vb1th2i7203j">
                <div className="flex items-center mr-4" data-id="element-17456" data-mp="vt28hwdsze8l">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17457" data-mp="qv0o984n58vj" />
                  <span data-id="element-17458" data-mp="qvk7qt9xw5bo">18 min read</span>
                </div>
                <div className="flex items-center" data-id="element-17459" data-mp="m3sda7nnxfg9">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-17460" data-mp="m2h8c4ihe1nk" />
                  <span data-id="element-17461" data-mp="i3iaf3v6355m">42,372 views</span>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-17462" data-mp="1ekcxu93vriyd">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-600 mr-1 flex-shrink-0" data-id="element-17463" data-mp="1emfxlkuu4qga" />
                Medically Reviewed by{' '}
                <span className="text-blue-600 underline ml-1" data-id="element-17464" data-mp="ubbw5qfahz7w">
                  Robert Hill, MD, FACP
                </span>
              </div>
            </div>
          </div>

          <div className="my-4" data-id="element-17465" data-mp="lb6u7vsv7t14">
            <img src="https://cdn.magicpatterns.com/uploads/hE7B4t4Tu9ARxkVLjZDSCM/Title.png" alt="GLP-1 side effects" className="w-full rounded-lg shadow-lg mb-3" data-id="element-17466" data-mp="lc8gkwfc01y5" />
          </div>

          <div className="my-4 border-l-4 border-gray-800 pl-6 py-4 bg-gradient-to-r from-gray-100 to-white shadow-sm" data-id="element-17467" data-mp="1d1ut1172gmbm">
            <p className="text-sm uppercase tracking-wide text-gray-500 mb-2 font-semibold" data-id="element-17468" data-mp="1i0ehb894ua75">
              ARTICLE SUMMARY
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic" data-id="element-17469" data-mp="147yfubvvqk8c">
              "What a Chicago nurse discovered after three years of crushing
              depression on semaglutide:
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-17470" data-mp="20rxiranidg72">
              6 science-backed strategies that address nausea, hair loss,
              fatigue, and the devastating 'flat feeling' without stopping your
              medication....
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-17471" data-mp="3v85xycx3u7bx">
              — now helping 120+ GLP-1 users monthly at her weight loss clinic."
            </p>
          </div>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17472" data-mp="32ji8e55bovsk">
            <div className="mb-1 flex items-center" data-id="element-17473" data-mp="2xknhefx7c0xd">
              <span className="font-medium mr-2" data-id="element-17474" data-mp="2xm89lyw1n7s2">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17475" data-mp="37il4h03brroe">
              <span className="font-medium mr-2" data-id="element-17476" data-mp="37h07l3tjfwnd">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlp6TipsG;